import { useCallback, useContext, useEffect, useState } from "react";

import { useSearchParams } from "next/navigation";

import { useCurrentUserContext } from "@/src/contexts/CurrentUserContext";
import { OrganizationEngagementFlagsContext } from "@/src/contexts/OrganizationEngagementFlagsContext";

export const useEmailEditorTour = () => {
  const searchParams = useSearchParams();
  const query = Object.fromEntries(searchParams.entries());
  const showTour = query.showTour === "true";

  const { engagementTourActive } = useCurrentUserContext();
  const { flags, loading: flagsLoading, updateFlags } = useContext(OrganizationEngagementFlagsContext);

  const [showRecipientsTour, setShowRecipientsTour] = useState(false);
  const [showTemplatesTour, setShowTemplatesTour] = useState(false);

  useEffect(() => {
    if (!flagsLoading && showTour && engagementTourActive) {
      const timeout = setTimeout(() => {
        if (!flags?.engagementEmailRecipientsTour) {
          setShowRecipientsTour(true);
          return;
        }
        if (!flags?.engagementEmailTemplatesTour) {
          setShowTemplatesTour(true);
        }
      }, 300);
      return () => clearTimeout(timeout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flagsLoading, engagementTourActive]);

  const onRecipientsTourClose = useCallback(() => {
    updateFlags({ engagementEmailRecipientsTour: true });
    setShowRecipientsTour(false);
    setTimeout(() => {
      setShowTemplatesTour(true);
    }, 300);
  }, [updateFlags]);

  const onTemplatesTourClose = useCallback(() => {
    updateFlags({ engagementEmailTemplatesTour: true });
    setShowTemplatesTour(false);
  }, [updateFlags]);

  const onSkipTour = useCallback(() => {
    updateFlags({ engagementEmailRecipientsTour: true, engagementEmailTemplatesTour: true });
    setShowRecipientsTour(false);
    setShowTemplatesTour(false);
  }, [updateFlags]);

  return {
    showRecipientsTour,
    showTemplatesTour,
    onRecipientsTourClose,
    onTemplatesTourClose,
    onSkipTour,
  };
};
